import React from "react";
import { useTheme } from "../../../../hooks/useTheme";
import { ModalBodyDiv } from "./ModalBodyStyles";
const ModalBody = ({ children, styles = {} }) => {
    const { Theme } = useTheme();
    const StylesOverride = { ...Theme.modal.body, ...styles };
    return React.createElement(ModalBodyDiv, { styles: StylesOverride }, children);
};
ModalBody.displayName = "ModalBody";
export default ModalBody;
//# sourceMappingURL=ModalBody.js.map